import { createFileRoute } from '@tanstack/react-router';

import { ThanksRoute } from '@mint-emails/recommendation/routes';

export const Route = createFileRoute('/recommendation/thanks')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ThanksRoute />;
}
